import MoneyDisplay from 'components/util/MoneyDisplay';
import LabelledData from 'pages/timecards/LabelledData';
import { FormattedMessage } from 'react-intl';
import { InvoiceExpense } from 'types/invoice-details';
import { ITEM_TOTALS_BAR } from '../SectionCard';

interface Props {
    currency: string;
    invoiceExpenses: InvoiceExpense[];
    isPaymentCurrencyMode?: boolean;
}

const getFinalAmount = (invoiceExpense: InvoiceExpense, isPaymentCurrencyMode?: boolean): number => {
    const log = isPaymentCurrencyMode ? invoiceExpense.calculationLog?.paymentCurrency : invoiceExpense.calculationLog;
    return log?.finalAmount ?? 0;
};

/** A case's expenses' final amounts in all, with VAT and without, to the cent. */
export const getExpenseTotals = (invoiceExpenses: InvoiceExpense[], isPaymentCurrencyMode?: boolean) => {
    const totalAmount =
        invoiceExpenses.reduce(
            (acc, invoiceExpense) => acc + getFinalAmount(invoiceExpense, isPaymentCurrencyMode) * 100,
            0
        ) / 100;

    const totalWithVat =
        invoiceExpenses.reduce((acc, invoiceExpense) => {
            if (invoiceExpense.calculationLog && !invoiceExpense.calculationLog.isNonVat) {
                return acc + getFinalAmount(invoiceExpense, isPaymentCurrencyMode) * 100;
            }
            return acc;
        }, 0) / 100;

    const totalWithoutVat =
        invoiceExpenses.reduce((acc, invoiceExpense) => {
            if (invoiceExpense.calculationLog && invoiceExpense.calculationLog.isNonVat) {
                return acc + getFinalAmount(invoiceExpense, isPaymentCurrencyMode) * 100;
            }
            return acc;
        }, 0) / 100;

    return { totalAmount, totalWithVat, totalWithoutVat };
};

const InvoiceExpenseTableTotals: React.FC<Props> = (props) => {
    const { currency, invoiceExpenses, isPaymentCurrencyMode } = props;
    const { totalAmount, totalWithVat, totalWithoutVat } = getExpenseTotals(invoiceExpenses, isPaymentCurrencyMode);

    return (
        <div className={ITEM_TOTALS_BAR}>
            <div className="flex flex-1 justify-between">
                <p className="text-body1">
                    <FormattedMessage id="invoices.details.totals" />
                </p>
                <div className="flex flex-row gap-2">
                    <LabelledData label="invoices.details.table.exp-with-VAT">
                        <span className="font-semibold">
                            <MoneyDisplay amount={totalWithVat} currency={totalWithVat ? currency : undefined} />
                        </span>
                    </LabelledData>
                    <LabelledData label="invoices.details.table.exp-wo-VAT">
                        <span className="font-semibold">
                            <MoneyDisplay amount={totalWithoutVat} currency={totalWithoutVat ? currency : undefined} />
                        </span>
                    </LabelledData>
                    <LabelledData label="invoices.details.table.exp-total">
                        <span className="font-semibold">
                            <MoneyDisplay amount={totalAmount} currency={currency} />
                        </span>
                    </LabelledData>
                </div>
            </div>
        </div>
    );
};

export default InvoiceExpenseTableTotals;
